import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ProductMedia, ProductVideo } from '../../../models/product-media.model';

@Component({
  selector: 'leap-media-video-modal',
  templateUrl: './media-video-modal-component.component.html',
  styleUrls: ['./media-video-modal-component.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MediaVideoModalComponentComponent implements OnInit, OnDestroy {
  
  @Input() productVideo: ProductVideo;
  @Output() onCloseClick: EventEmitter<void> = new EventEmitter();

  constructor(private _sanitizer: DomSanitizer) { }

  ngOnInit() {
  }

  ngOnDestroy() {
    
  }
  
  getYoutubeEmbeddedURL():SafeResourceUrl {
    if (this.productVideo == null) {
      return null;
    }
    let urlParams = (new URL(this.productVideo.url)).searchParams;
    let videoId = urlParams.get('v');

    return this._sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/" + videoId);
  }

  close() {
    this.onCloseClick.emit();
  }
}
